<template>
  <el-select
    v-model="invalue"
    filterable
    remote
    :size="size"
    :clearable="true"
    :placeholder="placeholder"
    @change="updateValue"
    :remote-method="query"
    :loading="loading">
    <el-option v-for="it in list" :value="it[valueField]" :label="it[textField]"></el-option>
  </el-select>
</template>

<script>
import ajax from './ajax'

export default {
  name: 'xselectRemote',
  props: ['value', 'placeholder', 'url', 'textField', 'valueField', 'defaultItem', 'size'],
  data() {
    return {
      loading: false,
      list: [],
      invalue: 0,
      isQuery: false
    }
  },
  created(){
    this.init()
  },
  watch: {
    value() {
      this.init();
    }
  },
  methods: {
    init(){
      this.isQuery = false;
      // this.invalue = this.value;
      if(this.textField == undefined){
        this.textField = 'name';
      }
      if(this.valueField == undefined){
        this.valueField = 'id';
      }
      if(this.value != null && typeof(this.value) == 'object'){
        if(typeof(this.defaultItem) == 'object'){
          let firstItem = {}
          firstItem[this.textField] = this.defaultItem[this.textField];
          firstItem[this.valueField] = this.defaultItem[this.valueField];
          let list = [];
          list[0] = firstItem;
          this.list = list;
          console.log(this.list[0]);
        }
        let invalue = JSON.parse(JSON.stringify(this.value))
        this.invalue = invalue[this.valueField];
        console.log(this.invalue);
        this.updateValue(this.invalue);
      }else{
        this.invalue = this.value;
      }
      let _self = this;
      setTimeout(() => {
        _self.isQuery = true;
      }, 300);
    },
    query(val) {
      if(!this.isQuery){
        return false;
      }
      this.loading = true;
      if(val !== ''){
        var _self = this;
        ajax(this, 'get', this.url, {str: val}, (res) => {
          _self.list = res.data.list;
        }, () => {
          _self.loading = false;
        })
      }else{
        this.list = [];
        this.loading = false;
      }
    },
    updateValue(val){
      this.$emit('input', val);
      this.$emit('selectFinish', val);
    }
  }
}
</script>


// WEBPACK FOOTER //
// select_remote.vue?14346c72